import { numberify } from "../numberify";

interface Display {
    window_inner_height: number;
    window_inner_width: number;
    screen_color_depth?: number;
    screen_pixel_depth?: number;
    screen_orientation_type?: OrientationType;
}

/**
 */
export function display(): Display {
    const result = {
        window_inner_height: numberify(window.innerHeight),
        window_inner_width: numberify(window.innerWidth),
    };
    const { screen } = window;
    screen &&
        Object.assign(result, {
            screen_color_depth: numberify(screen.colorDepth),
            screen_pixel_depth: numberify(screen.pixelDepth),
            screen_orientation_type: screen.orientation?.type,
        });
    return result;
}
